import { render, staticRenderFns } from "./WaitingTimeCard.vue?vue&type=template&id=5f43c415&scoped=true&lang=html&"
import script from "./WaitingTimeCard.vue?vue&type=script&lang=js&"
export * from "./WaitingTimeCard.vue?vue&type=script&lang=js&"
import style0 from "./WaitingTimeCard.vue?vue&type=style&index=0&id=5f43c415&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f43c415",
  null
  
)

export default component.exports